import { h } from 'preact';
import Close from 'utils/icon/close.svg';

const BlogFiltersModal = ({ onClose, children }) => (
  <div
    className='fixed inset-0 overflow-y-auto bg-white z-[1000] flex flex-col'
  >
    <div className='flex items-center justify-between [&.*]:text-black p-5'>
      <p className='text-headline-tag'>{window.TMW.Strings.filters.label}</p>
      <button
        className='flex items-center justify-center text-black w-3.5 h-3.5'
        type='button'
        aria-label='close'
        title='close'
        tabIndex='0'
        onClick={onClose}
      >
        <Close/>
      </button>
    </div>
    {children}
  </div>
);

export default BlogFiltersModal;
